// extracted by mini-css-extract-plugin
export default {"task":"Workflow_task__Heys8"};